import React from 'react'
import { useState, useEffect } from 'react'
import { graphql} from 'gatsby'
import { PrismicRichText} from '@prismicio/react'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import OtherOptionsMenu from '@components/OtherOptionsMenu'
import FeaturedItem from './FeaturedItem'

export const query = graphql `
query 
{
    allPrismicFeaturedHome{
      edges{
        node{     
            uid
            id
            type
            url
            data {
              page_title {
                text
              }
              page_description
              {
                text
                html
                raw
              }
          }
         
        }
      }
    }
  
}
`

const FeaturedContent = (props) => {
    const featuredPageInfo = props.data.allPrismicFeaturedHome.edges[0].node.data;
    const documents = props.pageContext.documents;
    const pageTitle = featuredPageInfo.page_title.text;
    const size = useWindowSize();
    function useWindowSize() {
        const [windowSize, setWindowSize] = useState({
          width: undefined,
          height: undefined,
        });
      
        useEffect(() => {
          // Handler to call on window resize
          function handleResize() {
            // Set window width/height to state
            setWindowSize({
              width: window.innerWidth,
              height: window.innerHeight,
            });
          }
          
          // Add event listener
          window.addEventListener("resize", handleResize);
          
          // Call handler right away so state gets updated with initial window size
          handleResize();
          
          // Remove event listener on cleanup
          return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
      
        return windowSize;
      }

    if(!documents) return null;
    if (typeof window !== "undefined"){
      return ( 
        <Layout>
        <SEO title={pageTitle} description="The newest content produced by the Research Division on a wide variety of topics" pathname={props.location.pathname}/>
        <Row>
          <Col lg={9} className="text-left">
              <h1>{featuredPageInfo.page_title.text}</h1> 
              <div>
              <PrismicRichText field={featuredPageInfo.page_description.raw}/>
              </div>
          </Col>
          <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
            <OtherOptionsMenu isAllContent={false}/>
          </Col>
        </Row>
        <hr className="my-4"/>
        <Row>
          <Col>
            {documents.map((item) => (
                <FeaturedItem featuredItem={item} windowSize={size} key={item.id}/>
            ))}
          </Col>
        </Row>
        </Layout>
      )
    }
    else {
      return null;
    }
}

export default FeaturedContent;